import ScrollController from '../../assets/js/controllers/scroll';
import SkrolliteEvent from './skrollite-event';

import { getRootOffsetBounds, validateParamNumber } from '../../assets/js/helpers';

export default class SkrolliteChild {

	config = {
		offset: {
			top: 0
		},
		skrollite: null // additional configurations from skrollite
	};

	coords = {
		container: null
	};

	el = {};

	flags = {
		isAboveViewport: false,
		isDisabled: false,
		isInViewport: false,
		isInViewportBottom: false,
		isInViewportTop: false,
		isLoaded: false,
		isOnScreen: false,
		isVideo: false,
		isVideoPlaying: false,

		isDesktop: false,
		isMobile: false,
		isTablet: false
	};

	promises = {
		videoPlay: null
	};

	// constructor

	constructor(container, config) {
		this.el = {
			container,
			videoWrapper: typeof container.getAttribute('data-skrollite-video') !== 'undefined' ? container : container.querySelector('[data-skrollite-video]'),
			video: container.querySelector('[data-skrollite-video] video')
		};

		this.config.offset.top = validateParamNumber(this.el.container, 'data-skrollite-offset-top', this.config.offset.top);
		this.config.skrollite = { ...config };

		//

		this.flags.isVideo = !!(this.el.videoWrapper && this.el.video);

		this.initialize();
	}

	// initialize

	initialize() {
		this.el.container.classList.add('is-skrollite-active');
	}

	//

	update() {
		const scrollTop = ScrollController.top;
		const scrollBottom = scrollTop + window.innerHeight;
		const { viewportGutters } = this.config.skrollite;
		let isChanged = false;

		if (!this.flags.isDisabled && (this.coords.container.width && this.coords.container.height)) {

			// check if any part is in viewport
			if (scrollTop + viewportGutters.top <= this.coords.container.bottom && scrollBottom - viewportGutters.bottom > this.coords.container.top + this.config.offset.top) {
				if (!this.flags.isInViewport) {
					this.flags.isInViewport = true;
					isChanged = true;
				}
			} else {
				if (this.flags.isInViewport) {
					this.flags.isInViewport = false;
					isChanged = true;
				}
			}

			// check if any part is on screen (ignores viewport gutters and offsets)
			if (scrollTop <= this.coords.container.bottom && scrollBottom > this.coords.container.top) {
				if (!this.flags.isOnScreen) {
					this.flags.isOnScreen = true;
					isChanged = true;
				}
			} else {
				if (this.flags.isOnScreen) {
					this.flags.isOnScreen = false;
					isChanged = true;
				}
			}

			// verbose mode includes additional information
			if (this.config.skrollite.isVerbose) {

				// check if bottom of element is in viewport
				if (scrollTop <= this.coords.container.bottom && scrollBottom - viewportGutters.bottom > this.coords.container.bottom) {
					if (!this.flags.isInViewportBottom) {
						this.flags.isInViewportBottom = true;
						isChanged = true;
					}
				} else {
					if (this.flags.isInViewportBottom) {
						this.flags.isInViewportBottom = false;
						isChanged = true;
					}
				}

				// check if top of element is in viewport
				if (scrollTop + viewportGutters.top <= this.coords.container.top && scrollBottom - viewportGutters.bottom > this.coords.container.top) {
					if (!this.flags.isInViewportTop) {
						this.flags.isInViewportTop = true;
						isChanged = true;
					}
				} else {
					if (this.flags.isInViewportTop) {
						this.flags.isInViewportTop = false;
						isChanged = true;
					}
				}

				// check if element is above viewport
				if (scrollTop + viewportGutters.top > this.coords.container.bottom) {
					if (!this.flags.isAboveViewport) {
						this.flags.isAboveViewport = true;
						isChanged = true;
					}
				} else {
					if (this.flags.isAboveViewport) {
						this.flags.isAboveViewport = false;
						isChanged = true;
					}
				}
			}
		}

		return isChanged;
	}

	render() {
		let isChanged = false;

		if (this.flags.isInViewport) {
			if (!this.el.container.classList.contains('is-in-viewport')) {
				this.el.container.classList.add('is-in-viewport');
				isChanged = true;
			}
			if (!this.el.container.classList.contains('is-not-first')) {
				this.el.container.classList.add('is-first-in');
			}
		} else {
			if (this.el.container.classList.contains('is-in-viewport')) {
				if (this.el.container.classList.contains('is-first-in') && !this.el.container.classList.contains('is-not-first')) {
					this.el.container.classList.add('is-not-first');
				}
				this.el.container.classList.remove('is-in-viewport', 'is-first-in');
				isChanged = true;
			}
		}

		if (this.flags.isOnScreen) {
			if (!this.el.container.classList.contains('is-on-screen')) {
				this.el.container.classList.add('is-on-screen');
				isChanged = true;
			}
		} else {
			if (this.el.container.classList.contains('is-on-screen')) {
				this.el.container.classList.remove('is-on-screen');
				isChanged = true;
			}
		}

		if (this.config.skrollite.isVerbose) {
			if (this.flags.isInViewportBottom) {
				if (!this.el.container.classList.contains('is-bottom-in-viewport')) {
					this.el.container.classList.remove('was-bottom-in-viewport');
					this.el.container.classList.add('is-bottom-in-viewport');
					isChanged = true;
				}
			} else {
				if (this.el.container.classList.contains('is-bottom-in-viewport')) {
					this.el.container.classList.remove('is-bottom-in-viewport');
					this.el.container.classList.add('was-bottom-in-viewport');
					isChanged = true;
				}
			}

			if (this.flags.isInViewportTop) {
				if (!this.el.container.classList.contains('is-top-in-viewport')) {
					this.el.container.classList.remove('was-top-in-viewport');
					this.el.container.classList.add('is-top-in-viewport');
					isChanged = true;
				}
			} else {
				if (this.el.container.classList.contains('is-top-in-viewport')) {
					this.el.container.classList.remove('is-top-in-viewport');
					this.el.container.classList.add('was-top-in-viewport');
					isChanged = true;
				}
			}

			if (this.flags.isAboveViewport) {
				if (!this.el.container.classList.contains('is-above-viewport')) {
					this.el.container.classList.add('is-above-viewport', 'is-not-first');
					isChanged = true;
				}
			} else {
				if (this.el.container.classList.contains('is-above-viewport')) {
					this.el.container.classList.remove('is-above-viewport');
					isChanged = true;
				}
			}
		}

		if (isChanged) {
			this.renderScrollChanges();
		}
	}

	// individual skrollite object updates

	renderScrollChanges() {
		if (this.flags.isInViewport) {
			this.el.container.dispatchEvent(new CustomEvent(SkrolliteEvent.VIEWPORT_IN));
			if (this.flags.isVideo && !this.flags.isVideoPlaying) {
				this.videoLoad();
			}
		} else {
			this.el.container.dispatchEvent(new CustomEvent(SkrolliteEvent.VIEWPORT_OUT));
			this.videoPause();
		}
	}

	renderResize() {
		if (this.flags.isVideo) {
			this.videoReload(this.flags.isInViewport);
		}
	}

	// video controls

	videoPlay() {
		if (!this.flags.isVideoPlaying) {
			this.flags.isVideoPlaying = true;
			this.el.container.classList.remove('is-playing');

			if (!this.promises.videoPlay) {
				try {
					const videoPromise = this.el.video.play();
					if (videoPromise) {
						this.promises.videoPlay = videoPromise;
						this.promises.videoPlay.then(() => {
							this.promises.videoPlay = null;
							if (!this.flags.isVideoPlaying) {
								this.el.video.pause();
							}
						});
					}
				} catch (error) {
					this.flags.isVideoPlaying = false;
					console.warn(error); // eslint-disable-line no-console
				}
			}
		}
	}

	videoPause() {
		if (this.flags.isVideo && this.flags.isVideoPlaying) {
			this.flags.isVideoPlaying = false;
			this.el.container.classList.remove('is-playing');
			if (!this.promises.videoPlay) {
				this.el.video.pause();
			}
		}
	}

	videoLoad(willPlay = true) {
		if (!this.flags.isLoaded) {

			let $sources = [];
			if (this.flags.isMobile) {
				$sources = this.el.video.querySelectorAll('source[data-src-mobile]');
			} else if (this.flags.isTablet) {
				$sources = this.el.video.querySelectorAll('source[data-src-tablet]');
			} else {
				$sources = this.el.video.querySelectorAll('source[data-src-desktop]');
			}

			let isValidSrc = false;
			for (let i = 0; i < $sources.length; i++) {
				const $source = $sources[i];
				const src = $source.getAttribute('data-src');
				if (src) {
					$source.setAttribute('src', src);
					isValidSrc = true;
				}
			}

			if (isValidSrc) {
				this.el.container.classList.add('is-video-active');

				try {
					this.flags.isLoaded = true;
					this.el.video.load();
					if (willPlay) {
						this.videoPlay();
					}
				} catch (error) {
					this.flags.isLoaded = false;
					console.warn(error); // eslint-disable-line no-console
				}
			}

		} else {
			this.videoPlay();
		}
	}

	videoUnload() {
		if (this.flags.isLoaded) {
			this.flags.isLoaded = false;
			const $sources = this.el.video.children;
			for (let i = 0; i < $sources.length; i++) {
				const $source = $sources[i];
				$source.removeAttribute('src');
			}
			this.el.container.classList.remove('is-video-active');
		}
	}

	videoReload(willPlay = true) {
		if (this.flags.isVideoPlaying || this.flags.isInViewport) {
			this.videoUnload();
			this.videoLoad(willPlay);
		}
	}

	//

	measure() {
		this.coords.container = getRootOffsetBounds(this.el.container);
	}

	setResizeFlags(isMobile, isTablet, isDesktop) {
		let willRender = false;

		if (this.flags.isMobile !== isMobile || this.flags.isTablet !== isTablet || this.flags.isDesktop !== isDesktop) {
			willRender = true;
		}

		this.flags.isMobile = isMobile;
		this.flags.isTablet = isTablet;
		this.flags.isDesktop = isDesktop;

		if (willRender) {
			this.renderResize();
		}
	}

	//

	destroy() {
		this.flags.isVideoPlaying = false;
	}

}
